<template>
  <button
    v-if="onClick || isButton"
    type="button"
    tabindex="-1"
    :class="`${el}__iconButton`"
    @click="click"
    @mouseenter="mouseenter"
  >
    <svg v-svg :symbol="name" role="presentation" :class="classes()"></svg>
  </button>
  <svg
    v-svg
    v-else
    :symbol="name"
    role="presentation"
    @click="click"
    @mouseenter="mouseenter"
    :class="classes()"
  ></svg>
</template>

<script>
/**
 * New Icon?
 *
 * 1. Find the icon at https://remixicon.com/
 * 2. Copy svg markup to svg-sprite (path: public/assets/svg/sprite.svg)
 * 3. Replace <svg></svg> tag with <symbol></symbol> tag and set the icon name as id (eg. id="check-line")
 * 3. Write icon name to "IconNameTypes" in src/constants/enums.js
 *
 * Usage: <Icon name="check-line" />
 */

import { IconNameTypes, ColorTypes } from '@/constants/enums';

export default {
  name: 'Icon',
  props: {
    size: {
      type: String,
      default: 'm',
      validator: (val) => ['s', 'm', 'l', 'xl', 'xxl', 'xxxl'].includes(val),
    },
    name: {
      type: String,
      validator: (val) => IconNameTypes.includes(val),
    },
    width: Number,
    color: {
      type: String,
      default: 'neutral100',
      validator: (val) => ColorTypes.includes(val),
    },
    onClick: Function,
    isButton: Boolean,
  },
  data() {
    return {
      el: 'o-icon',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--${this.size}`]: this.size,
          [`${el}--${this.color}`]: this.color,
        };
      },
    };
  },
  methods: {
    click() {
      if (this.onClick) {
        this.onClick();
      }
    },
    mouseenter() {
      this.$emit('mouseenter');
    },
  },
};
</script>
